import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store/store';

export interface IService {
    alias: string
    description: string
    id: number
    isactive: true
    layers: ILayer[]
    name: string
    perm: number
    priority: number
    type: string
    url: string
    workspace: string
}

export interface ILayerGroup {
    name: string
    created_by: number
    created_date: string
    id: number
    layers: ILayer[]
    alias: string,
    priorty: number
}

export interface ILayer {
    alias: string
    desription: string
    fields: IField[]
    geomtype: string
    id: number
    name: string
    perm: number
    priority: number
    public: boolean
    service_id: number
    style_id: number
    visible: boolean
    opacity: number
    labeling: number
}

export interface IField {
    alias: string
    created: string
    domain_id: null
    has_domain: boolean
    id: number
    layer_id: number
    name: string
    nullable: boolean
    priority: number
    type: string
    domain?: IDomain[]
}

export interface IDomain {
    desc: string
    id: number
}

export interface IStyle {
    fill_color: string
    fill_opacity: number
    icon: string
    id: number
    max_zoom: number
    min_zoom: number
    name: string
    shape: string
    stroke_color: string
    stroke_opacity: number
    stroke_width: number
    type: string
}

export interface LayersState {
    services: IService[];
    layerGroups: ILayerGroup[];
    layerNodes: any[];
    styles: IStyle[];
    tableLayer: ILayer | null;
    status: 'idle' | 'loading' | 'failed';
    importLayerGroup: any,
    layer:any
}

const initialState: LayersState = {
    services: [],
    layerGroups: [],
    styles: [],
    layerNodes: [],
    tableLayer: null,
    status: 'idle',
    importLayerGroup: null,
    layer:null
};


export const layerSlice = createSlice({
    name: 'layer',
    initialState,
    reducers: {
        setServices: (state: LayersState, action) => {
            state.services = action.payload;
        },
        setLayerStyles: (state: LayersState, action) => {
            state.styles = action.payload;
        },
        setTableLayer: (state: LayersState, action) => {
            state.tableLayer = action.payload;
        },
        setLayerGroups: (state: LayersState, action) => {
            state.layerGroups = action.payload;
        },
        setImportLayerGroup: (state: LayersState, action) => {
            state.importLayerGroup = action.payload;
        },
        setLayerNodes: (state: LayersState, action) => {
            state.layerNodes = action.payload;
        },
        setSelectedLayer: (state: LayersState, action) => {
            state.layer = action.payload;
        }
    }
});

export const { setServices, setTableLayer,setSelectedLayer, setLayerGroups, setImportLayerGroup, setLayerNodes } = layerSlice.actions;

export const selectServices = (state: RootState) => state.layer.services;
export const selectLayerGroup = (state: RootState) => state.layer.layerGroups;
export const selectLayerStyles = (state: RootState) => state.layer.styles;
export const selectTableLayer = (state: RootState) => state.layer.tableLayer;

export default layerSlice.reducer;